import React from "react";
import { useSelector } from "react-redux";
import "./style.css";
import uuidv4 from "uuid/v4";
import numeral from "numeral";
import { FormattedMessage } from "react-intl";
import modelConfig from "./config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ReportBalanceSheet = ({ goToNewModel, paramsFromUrl, setCsvData }) => {
  const reports = useSelector(state => state.reports);
  let cloneReport = reports?.search?.report;

  const renderRows = (kind, type) => {
    let items = [];
    let newRows = [];
    const specialAccounts = ["40", "14"];
    if (
      cloneReport &&
      cloneReport[kind] &&
      cloneReport[kind][type] &&
      cloneReport[kind][type].accounts
    ) {
      cloneReport[kind][type].accounts.map(it => {
        let toAdd = true;
        if (
          it.accountId.indexOf("/") > -1 ||
          specialAccounts.indexOf(it.accountId) > -1
        ) {
          if (it.accountId.split("/").length === 3) {
            it.hasFather = true;
            it.hasLedger = true;
          }
        } else {
          toAdd = false;
        }
        if (toAdd) {
          newRows.push(it);
        }
        return null;
      });
      cloneReport[kind][type].totalRows = newRows.length;
      newRows.map(it => {
        return items.push(<div
          key={"dbx-reports-sheet-body-row_" + uuidv4()}
          className={
            "dbx-reports-sheet-body-table-row movement" +
              (it.hasFather ? " hasFather" : "") +
              (it.hasLedger ? " hasLedger" : "")
          }
        >
          <div className="movement-accountName">
            {it.hasFather && <div>{`${it.accountId}`}</div>}
            <div className="movement-accountName-text">
              {it.accountName.toLowerCase()}
            </div>
          </div>
          <div className="movement-amount">
            {numeral(it.value).format("0,0.00")} €{" "}
            {it.hasLedger ? (
              <div
                style={{ cursor: it.hasLedger ? "pointer" : "default" }}
                className="movement-accountName-goToLedger"
                onClick={() => {
                  if (it.hasLedger) {
                    const data = {
                      ...paramsFromUrl,
                      accountId: it.accountId,
                      accountName: it.accountName[0] + it.accountName.substr(1, 4).toLowerCase(),
                      detail: true
                    };
                    goToNewModel(data, "ledger");
                  }
                }}
              >
                <FontAwesomeIcon icon={["far", "arrow-right"]} />
              </div>
            ) : (
              <div className="movement-accountName-goToLedger">&nbsp;</div>
            )}
          </div>
        </div>);
      });
    }
    return items;
  };

  const renderRowsDiff = (
    kind, type, type2
  ) => {
    let items = [];
    if (
      cloneReport[kind][type].totalRows < cloneReport[kind][type2].totalRows
    ) {
      for (
        let i = 0;
        i <
        cloneReport[kind][type2].totalRows - cloneReport[kind][type].totalRows;
        i++
      ) {
        items.push(<div
          key={"dbx-reports-sheet-body-row_" + uuidv4()}
          className={"dbx-reports-sheet-body-table-row movement"}
        >
            &nbsp;
        </div>);
      }
    }
    return items;
  };

  const renderTotals = (kind, type) => {
    let items = [];
    if (cloneReport && cloneReport[kind] && cloneReport[kind][type]) {
      items.push(<div
        key={"dbx-reports-sheet-body-row_" + uuidv4()}
        className="dbx-reports-sheet-body-table-row reportTotal"
      >
        <div>
          {kind === "balanceSheet" ? "Stato patrimoniale" : "Totale"}{" "}
          {kind === "balanceSheet"
            ? type === "credit"
              ? "passivo"
              : "attivo"
            : type === "credit"
              ? "ricavi"
              : "costi"}{" "}
          {kind === "balanceSheet" ? "totale" : ""}
        </div>
        <div className="movement-amount">
          {numeral(cloneReport[kind][type].total).format("0,0.00")} €
          <div>&nbsp;</div>
        </div>
      </div>);
    }
    return items;
  };

  const renderOperatingResult = (kind, type) => {
    let items = [];
    if (cloneReport && cloneReport[kind]) {
      let diff = cloneReport[kind].credit.total - cloneReport[kind].debit.total;
      items.push(<div
        key={"dbx-reports-sheet-body-row_" + uuidv4()}
        className="dbx-reports-sheet-body-table-row reportTotal"
      >
        <div>
          {(type === "credit" && diff <= 0) || (type === "debit" && diff >= 0)
            ? "Risultato d'esercizio"
            : " "}
        </div>
        <div className="movement-amount">
          {(type === "credit" && diff <= 0) || (type === "debit" && diff >= 0)
            ? numeral(diff)
              .format("0,0.00")
              .replace("-", "") + " €"
            : " "}
          <div>&nbsp;</div>
        </div>
      </div>);
    }
    return items;
  };

  const renderGroup = (groupBy = ["generic"]) => {
    let items = [];
    const checkNoGroup = groupBy.length === 1 && groupBy[0] === "generic";
    groupBy.map(kind => {
      return items.push(<React.Fragment key={"dbx-reports-sheet-body-kind_" + kind}>
        {!checkNoGroup && (
          <div className="dbx-reports-sheet-body-title">
            <FormattedMessage
              id={"reports.balance.kinds." + kind + ".title"}
            />
          </div>
        )}
        <div className="dbx-reports-sheet-body-table">
          <div className="dbx-reports-sheet-body-table-col">
            <div className="dbx-reports-sheet-body-table-row header-primary">
              <div>
                <FormattedMessage
                  id={"reports.balance.kinds." + kind + ".debitTitle"}
                />
              </div>
              <div>Saldi d'esercizio</div>
            </div>
            {renderRows(kind, "debit")}
            {renderRowsDiff(
              kind, "debit", "credit"
            )}
            {renderTotals(kind, "debit")}
            {renderOperatingResult(kind, "debit")}
          </div>
          <div className="dbx-reports-sheet-body-table-col">
            <div className="dbx-reports-sheet-body-table-row header-primary">
              <div>
                <FormattedMessage
                  id={"reports.balance.kinds." + kind + ".creditTitle"}
                />
              </div>
              <div>Saldi d'esercizio</div>
            </div>
            {renderRows(kind, "credit")}
            {renderRowsDiff(
              kind, "credit", "debit"
            )}
            {renderTotals(kind, "credit")}
            {renderOperatingResult(kind, "credit")}
          </div>
        </div>
      </React.Fragment>);
    });
    return items;
  };

  return (
    <div className="dbx-reports-sheet-root">
      {
        Object.keys(cloneReport).length > 0 && <div className="dbx-reports-sheet-body">
          {modelConfig.groupBy ? renderGroup(modelConfig.groupBy) : renderGroup()}
        </div>
      }
    </div>
  );
};

export default ReportBalanceSheet;
